import { useTranslation } from 'react-i18next';
import { ErrMessageKeys, ValidationRules } from '@myme/utils';

// Password restrictions
// - Minimum eight characters
// - At least one uppercase letter
// - At least one lowercase letter
// - At least one number
// - optional special characters
const passwordPattern = RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\w~@#$%^&*+=`|{}:;!.?"()[\]-]{8,}$/);
const minPasswordLength = 8;

export const useNewPasswordForm = (password: string) => {
  const { t } = useTranslation();

  const validationRules: ValidationRules = {
    password: { required: true, minLength: minPasswordLength, pattern: passwordPattern },
    passwordConfirm: { required: true, validate: value => (value as string) === password }
  };

  const errorMessageKeys: ErrMessageKeys = {
    password: t('errors.validation.password_register', { minLength: minPasswordLength }),
    passwordConfirm: t('errors.validation.password_confirm')
  };

  return {
    rules: validationRules,
    errMessage: errorMessageKeys
  };
};
